export const breadcrumb = {
  title: 'HLR',

  requests: {
    index: 'Meminta'
  }
};
